import Versionsinformationen from "./Versionsinformationen/Versionsinformationen.vue";

export default {
  Versionsinformationen,
};
